import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import {
  BackButton,
  FormFooter,
  PrimaryActions,
  SaveDraftButton,
} from '../../../lessons/components/LessonsFormFooter/styled'

interface BlocksFormFooterProps {
  draggable: boolean
  buttonLoading: boolean
  hasLessonName: boolean
  saveDisabled: boolean
  onBack: () => void
  onSave: () => void
}

export const BlocksFormFooter: React.FC<BlocksFormFooterProps> = ({
  draggable,
  buttonLoading,
  hasLessonName,
  saveDisabled,
  onBack,
  onSave,
}) => {
  const { t } = useTranslation()

  const isSaveDisabled =
    buttonLoading || draggable || saveDisabled || !hasLessonName

  const saveButton = (
    <SaveDraftButton
      type="button"
      disabled={isSaveDisabled}
      onClick={() => !isSaveDisabled && onSave()}
    >
      {buttonLoading ? (
        <FontAwesomeIcon icon={faSpinner} spin aria-hidden />
      ) : null}
      {t('administration.blocks.buttons.save')}
    </SaveDraftButton>
  )

  return (
    <FormFooter>
      <BackButton
        type="button"
        disabled={draggable}
        onClick={() => !draggable && !buttonLoading && onBack()}
      >
        <FontAwesomeIcon icon={faArrowLeft} aria-hidden />
        {t('administration.lessons.buttons.back')}
      </BackButton>
      <PrimaryActions>
        {hasLessonName ? (
          saveButton
        ) : (
          <CommonToolTip
            text={t('administration.blocks.buttons.saveTooltip')}
            position="top"
          >
            <div>{saveButton}</div>
          </CommonToolTip>
        )}
      </PrimaryActions>
    </FormFooter>
  )
}

export default BlocksFormFooter
